


















































































































import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator'
import { mdiChevronDown, mdiChevronUp, mdiPlay } from '@mdi/js'
import 'swiper/swiper.scss'
import { filterDate } from '~/assets/filters/date'
import { IReview, IReviewVoteResponse } from '~/assets/interfaces/reviews'
import { getProductReviewVoteApi } from '~/assets/config/api-path'
import ComponentRating2 from '~/components/rating/rating-2.vue'
import ComponentImage from '~/components/images/image.vue'
import ComponentIcon from '~/components/icon/icon.vue'

@Component({
  components: {
    ComponentImage,
    ComponentIcon,
    ComponentRating2,
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentVideo: () => import('~/components/video/video.vue'),
  },
  filters: {
    filterDate,
  },
})
export default class ComponentReviewItem extends Vue {
  @Prop({ type: Object, default: () => {} }) private item!: IReview
  @Prop({ type: Number, required: true }) private productId!: number
  @Prop({ type: Boolean, default: false }) private isTop!: boolean
  private helpfulYes = 0
  private helpfulNo = 0
  private userVote: 'yes' | 'no' | null = null
  private isVoteLoading = false

  private photoPopupOpen(item: IReview | null = null, start: number = 0) {
    this.$emit('openGallery', { item, start })
  }

  private showFeedback = false
  private toggleFeedback() {
    this.showFeedback = !this.showFeedback
  }

  private isShowVideo = false
  private videoPopupWidth = 1104

  /**
   * ComponentVideo задаёт высоту через padding-top от ШИРИНЫ (по соотношению
   * сторон). У вертикальных видео WB (9:16) высота получается больше ширины и
   * попап вылезает за экран. Поэтому подбираем ширину так, чтобы вычисленная
   * из неё высота влезала во вьюпорт.
   */
  private onVideoMetadata(payload: {
    playerType: 'youtube' | 'rutube' | 'video'
    ratio: number
  }) {
    if (!process.client || payload.playerType !== 'video' || !payload.ratio) {
      return
    }

    const isNarrow = window.innerWidth < 768
    const horizontalPadding = isNarrow ? 32 : 80
    const maxContentWidth =
      Math.max(280, window.innerWidth * 0.9) - horizontalPadding
    const maxContentHeight = Math.max(280, window.innerHeight * 0.8)
    // ширина, при которой высота (width / ratio) не превысит maxContentHeight
    const contentWidth = Math.min(
      maxContentWidth,
      maxContentHeight * payload.ratio
    )

    // Нижняя граница намеренно маленькая: ограничение по высоте важнее, иначе
    // на низких вьюпортах (телефон в ландшафте) видео снова вылезет за экран.
    this.videoPopupWidth = Math.min(
      Math.max(Math.round(contentWidth + horizontalPadding), 200),
      1104
    )
  }

  @Watch('item', { immediate: true })
  private onItemChange() {
    this.helpfulYes = this.item.helpfulYes || 0
    this.helpfulNo = this.item.helpfulNo || 0
    this.userVote = this.item.userVote || null
  }

  private vote(type: 'yes' | 'no') {
    if (!this.$auth.loggedIn) {
      this.$nuxt.$emit('open-auth-popup')
      return
    }
    if (this.userVote === type || this.isVoteLoading) {
      return
    }

    this.sendVote(type)
  }

  private async sendVote(type: 'yes' | 'no') {
    this.isVoteLoading = true
    const previousVote = this.userVote
    try {
      const response: IReviewVoteResponse = await this.$axios.$post(
        getProductReviewVoteApi(this.productId),
        {
          reviewId: this.item.id,
          vote: type,
          previousVote,
        }
      )

      if (response && response.success === false) {
        return
      }

      if (
        response &&
        typeof response.helpfulYes === 'number' &&
        typeof response.helpfulNo === 'number'
      ) {
        this.helpfulYes = response.helpfulYes
        this.helpfulNo = response.helpfulNo
        this.userVote = response.userVote || type
      } else {
        this.applyVoteLocally(type, previousVote)
      }
    } catch (_error) {
      // keep previous state on request error
    } finally {
      this.isVoteLoading = false
    }
  }

  private applyVoteLocally(
    type: 'yes' | 'no',
    previousVote: 'yes' | 'no' | null
  ) {
    if (previousVote === 'yes') {
      this.helpfulYes = Math.max(0, this.helpfulYes - 1)
    }
    if (previousVote === 'no') {
      this.helpfulNo = Math.max(0, this.helpfulNo - 1)
    }

    if (type === 'yes') {
      this.helpfulYes += 1
    } else {
      this.helpfulNo += 1
    }

    this.userVote = type
  }

  private icons = {
    mdiChevronDown,
    mdiChevronUp,
    mdiPlay,
  }
}
